'use strict';

exports.__esModule = true;
exports.RootConnector = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context3 = require('@prisma-cms/context');

var _context4 = _interopRequireDefault(_context3);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _App = require('../App');

var _App2 = _interopRequireDefault(_App);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var FrontEditorRoot = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(FrontEditorRoot, _PrismaCmsComponent);

  function FrontEditorRoot(props) {
    _classCallCheck(this, FrontEditorRoot);

    var _this = _possibleConstructorReturn(this, _PrismaCmsComponent.call(this, props));

    var _props$inEditMode = props.inEditMode,
        inEditMode = _props$inEditMode === undefined ? false : _props$inEditMode;
    _this.state = _extends({}, _this.state, {
      inEditMode: inEditMode
    });
    return _this;
  }

  FrontEditorRoot.prototype.componentWillMount = function componentWillMount() {
    var locales = {
      ru: {
        values: {
          Cancel: "Отмена",
          Close: "Закрыть",
          "Edit template": "Редактировать шаблон"
        }
      }
    };
    this.initLocales(locales);
    _PrismaCmsComponent.prototype.componentWillMount && _PrismaCmsComponent.prototype.componentWillMount.call(this);
  };

  FrontEditorRoot.prototype.render = function render() {
    var _this2 = this;

    var _context = this.context,
        Grid = _context.Grid,
        currentUser = _context.user,
        openLoginForm = _context.openLoginForm;

    var _props = this.props,
        _props$data = _props.data,
        loading = _props$data.loading,
        objects = _props$data.objects,
        createTemplate = _props.createTemplate,
        updateTemplate = _props.updateTemplate,
        CustomComponents = _props.CustomComponents,
        inEditModeNull = _props.inEditMode,
        first = _props.first,
        orderBy = _props.orderBy,
        clonable = _props.clonable,
        other = _objectWithoutProperties(_props, ['data', 'createTemplate', 'updateTemplate', 'CustomComponents', 'inEditMode', 'first', 'orderBy', 'clonable']);

    var inEditMode = this.state.inEditMode;
    var content = null;

    var _ref = currentUser || {},
        currentUserId = _ref.id;
    /**
     * Если не был получен ни один шаблон, то предлагаем создать новый.
     * Если есть, то выводим первый
     */


    var templates = objects || [];

    var editorProps = _extends({
      CustomComponents: [].concat(CustomComponents || []),
      createTemplate: createTemplate,
      updateTemplate: updateTemplate
    }, other);

    if (!templates.length) {
      if (loading) {// content = "Loading...";
      } else {
        // content = <Grid
        //   container
        // >
        // </Grid>;
        if (!currentUserId) {
          content = _react2.default.createElement(_Button2.default, {
            variant: 'raised',
            color: 'secondary',
            onClick: function onClick(event) {
              return openLoginForm();
            }
          }, 'Signin');
        } else {
          var object = {
            name: "Page",
            component: "Page",
            rank: 1000,
            props: {},
            components: []
          };
          content = _react2.default.createElement(_App2.default // key="new"
          , _extends({
            inEditMode: true,
            data: {
              object: object
            },
            _dirty: object,
            mutate: createTemplate
          }, editorProps));
        }
      }
    } else {
      var template = templates[0];
      var toolbar = null;
      var createdById = template.CreatedBy.id;
      /**
       * Если разрешено клонировать шаблоны или владелец - текущий пользователь, то выводим кнопки
       */

      if (clonable || currentUserId && currentUserId === createdById) {
        toolbar = _react2.default.createElement(Grid, {
          rel: 'noindex, nofollow',
          container: true,
          style: {
            // flexDirection: "row-reverse",
            position: "fixed",
            bottom: 0,
            right: 0,
            width: "auto",
            background: "rgba(255,255,255,0.5)",
            zIndex: 2000
          }
        }, _react2.default.createElement(Grid, {
          item: true
        }, _react2.default.createElement(_Button2.default, {
          size: 'small',
          onClick: function onClick(event) {
            return _this2.setState({
              inEditMode: !inEditMode
            });
          },
          variant: 'raised'
        }, inEditMode ? this.lexicon("Close") : this.lexicon("Edit template"))));
      }

      if (currentUserId && currentUserId === createdById) {
        Object.assign(editorProps, {
          mutate: updateTemplate
        });
      } else {
        var templateId = template.id,
            name = template.name,
            props = template.props,
            components = template.components;
        Object.assign(editorProps, {
          mutate: createTemplate // _dirty: {
          //   name,
          //   props,
          //   components,
          //   Parent: {
          //     connect: {
          //       id: templateId,
          //     },
          //   },
          // },

        });
      }

      content = _react2.default.createElement(_react.Fragment, {
        key: template ? template.id + '-' + template.updatedAt : "null"
      }, toolbar, _react2.default.createElement(_App2.default, _extends({
        inEditMode: inEditMode,
        data: {
          object: template
        }
      }, editorProps)));
    }

    return _PrismaCmsComponent.prototype.render.call(this, content);
  };

  return FrontEditorRoot;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  data: _propTypes2.default.object.isRequired,
  createTemplate: _propTypes2.default.func.isRequired,
  updateTemplate: _propTypes2.default.func.isRequired,
  inEditMode: _propTypes2.default.bool.isRequired,
  clonable: _propTypes2.default.bool.isRequired
}), _class.defaultProps = {
  inEditMode: false,
  clonable: true
}, _temp);
var RootConnector = exports.RootConnector = (_temp2 = _class2 = function (_Component) {
  _inherits(RootConnector, _Component);

  function RootConnector() {
    _classCallCheck(this, RootConnector);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  RootConnector.prototype.componentWillMount = function componentWillMount() {
    var _context$query = this.context.query,
        templates = _context$query.templates,
        createTemplateProcessor = _context$query.createTemplateProcessor,
        updateTemplateProcessor = _context$query.updateTemplateProcessor;
    var View = this.props.View;
    this.Renderer = (0, _reactApollo.compose)((0, _reactApollo.graphql)((0, _graphqlTag2.default)(templates)), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(createTemplateProcessor), {
      name: "createTemplate"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateTemplateProcessor), {
      name: "updateTemplate"
    }))(View);
    _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.call(this);
  };

  RootConnector.prototype.render = function render() {
    // return null;
    var _props2 = this.props,
        View = _props2.View,
        currentProjectOnly = _props2.currentProjectOnly,
        other = _objectWithoutProperties(_props2, ['View', 'currentProjectOnly']);

    var Renderer = this.Renderer;
    var _context2 = this.context,
        currentUser = _context2.user,
        uri = _context2.uri;

    var _ref2 = currentUser || {},
        currentUserId = _ref2.id;

    var OR = [{
      Parent: null,
      component: "Page"
    }];
    var conditions = {}; // if (currentUserId) {
    //   OR.push({
    //     CreatedBy: {
    //       id: currentUserId,
    //     },
    //   });
    //   Object.assign(conditions, {
    //     orderBy: "createdAt_DESC",
    //     first: 2,
    //   });
    // }
    // else {
    //   Object.assign(conditions, {
    //     orderBy: "rank_DESC",
    //     first: 1,
    //   });
    // }

    var where = {
      OR: OR
    };

    if (currentProjectOnly) {
      var domain = uri.hostname() || "localhost"; // if(!domain) {
      //   console.error("Can not get domain");
      //   return null;
      // }

      Object.assign(where, {
        PrismaProject: {
          domain: domain
        }
      });
    }

    Object.assign(conditions, {
      orderBy: "rank_DESC",
      first: 1
    });
    Object.assign(conditions, {
      where: where
    });
    return _react2.default.createElement(Renderer // key={currentUserId}
    , _extends({}, conditions, other));
  };

  return RootConnector;
}(_react.Component), _class2.contextType = _context4.default, _class2.defaultProps = {
  View: FrontEditorRoot,
  // first: 1,
  currentProjectOnly: true
}, _temp2);
RootConnector.propTypes = process.env.NODE_ENV !== "production" ? {
  View: _propTypes2.default.func.isRequired,
  // first: PropTypes.number,
  // Get templates for current project only (via domain)
  currentProjectOnly: _propTypes2.default.bool.isRequired
} : {};
exports.default = RootConnector;